import { Dialog, Grid } from "@material-ui/core";

const Confirm = ({
  open = false,
  onClose = () => {},
  choice = 2,
  question = "Question",
  choices = [{ title: "Confirm", onClick: () => {} }],
}) => {
  let grid = 12 / choice;
  return (
    <Dialog open={open}>
      <h3 style={{ textAlign: "center" }}>{question}</h3>
      <Grid container className="confirm">
        <Grid item xs={grid}>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
        </Grid>
        {choices.map((a, aKey) => (
          <Grid item xs={grid}>
            <button
              type="button"
              style={{ background: process.env.REACT_APP_COLOR, color: "#fff" }}
              onClick={() => a.onClick()}
            >
              {a.title}
            </button>
          </Grid>
        ))}
      </Grid>
    </Dialog>
  );
};

export default Confirm;
